<sl-paged-grid [config]="gridConfig" />
